/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class EncryptionKey {
  /**
  * The ID of the encryption key
  */
  'id': string;
  /**
  * The full name of the encryption key
  */
  'arn': string;
  /**
  * The alias name of the encryption key
  */
  'aliasName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "arn",
      "baseName": "arn",
      "type": "string",
      "format": ""
    },
    {
      "name": "aliasName",
      "baseName": "aliasName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EncryptionKey.attributeTypeMap;
  }

  public constructor() {
  }
}

